// src/slices/1-auth/2-myProfile/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getMyProfile, updateMyProfile } from "./thunk";

const initialState = { profile: null, loading: false, error: null, successMessage: null };

const myProfileSlice = createSlice({
  name: "myProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 👉 GET PROFILE
      .addCase(getMyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data;
        state.error = null;
      })
      .addCase(getMyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 👉 UPDATE PROFILE
      .addCase(updateMyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(updateMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data;
        state.successMessage = "Profile updated successfully";
        state.error = null;
      })
      .addCase(updateMyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default myProfileSlice.reducer;
